module.exports = __webpack_public_path__ + "img/steam-shipyard.48de58a1.webp";